import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
type ScarcityBarProps = {
  tone?: 'light' | 'dark';
};
export function ScarcityBar({
  tone = 'light'
}: ScarcityBarProps) {
  const dark = tone === 'dark';
  return <div className={`w-full rounded-2xl border p-4 ${dark ? 'border-white/15 bg-white/5' : 'border-alert/20 bg-alert-light'}`} data-id="element-269" data-mp="2l2trojzohnp6">
      <div className="flex items-center justify-between gap-3" data-id="element-270" data-mp="2b6gv9ecr0vqq">
        <span className={`flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider ${dark ? 'text-white' : 'text-alert-deep'}`} data-id="element-271" data-mp="2g5tlm92twky2">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-272" data-mp="228eqcnpw9iy6" />
          Limited launch price
        </span>
        <span className={`font-display text-lg font-bold ${dark ? 'text-white' : 'text-alert-deep'}`} data-id="element-273" data-mp="276zpejtetwl1">
          93% reserved
        </span>
      </div>
      <div className={`mt-2.5 h-4 w-full overflow-hidden rounded-full ${dark ? 'bg-white/15' : 'bg-white'}`} role="progressbar" aria-valuenow={93} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots reserved" data-id="element-274" data-mp="5cgzorpuj8z2">
        <motion.div className="h-full rounded-full bg-alert" initial={{
        width: '40%'
      }} whileInView={{
        width: '93%'
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-275" data-mp="3dcy0cl5por4l" />
      </div>
      <p className={`mt-2.5 text-center text-[15px] font-semibold ${dark ? 'text-white' : 'text-ink'}`} data-id="element-276" data-mp="2gmfbfefk7ca3">
        Only <span className={dark ? 'text-radar' : 'text-alert-deep'} data-id="element-277" data-mp="2umpzk9phicrk">7 spots</span> remaining at the promotional
        price!
      </p>
    </div>;
}